import React from 'react'
import { Redirect, Switch } from 'react-router-dom'

import { ROUTE_URLS } from 'router/routes'

export function createRoutes(modules) {
  const routesFromModules = modules.map(module => module.getRoutes())
  return (
    <>
      <Switch>
        <Redirect exact from="/" to={ROUTE_URLS.MAIN()} />
        {routesFromModules}
      </Switch>
    </>
  )
}
